import { TranslocoDirective, provideTranslocoScope } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CustomerContact } from '../../../../interfaces/customer-contacts.model';

type ContactDialogData = {
  mode?: 'add' | 'edit';
  contact?: CustomerContact;
};

@Component({
  providers: [provideTranslocoScope('customers')],
  selector: 'cus-customers-add-contact-dialog-component',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggleModule,
    TranslocoDirective,
  ],
  templateUrl: './customers-add-contact-dialog-component.html',
  styleUrl: './customers-add-contact-dialog-component.scss',
})
export class CustomersAddContactDialogComponent {
  private readonly data = inject<ContactDialogData | null>(MAT_DIALOG_DATA, { optional: true });
  addContactForm: FormGroup;
  readonly dialogMode = this.data?.mode ?? 'add';
  readonly dialogTitleKey = this.dialogMode === 'edit' ? 'contacts.form.editTitle' : 'contacts.form.addTitle';

  constructor(
    private dialogRef: MatDialogRef<CustomersAddContactDialogComponent>,
    private formBuilder: FormBuilder,
  ) {
    this.addContactForm = this.formBuilder.group({
      nomeCognome: [this.data?.contact?.nominativo ?? '', [Validators.required, Validators.maxLength(100)]],
      telefono: [this.data?.contact?.telefono ?? '', Validators.maxLength(20)],
      cellulare: [this.data?.contact?.cellulare ?? '', Validators.maxLength(20)],
      fax: [this.data?.contact?.fax ?? '', Validators.maxLength(20)],
      email: [this.data?.contact?.email ?? '', Validators.maxLength(100)],
      ruolo: [this.data?.contact?.ruolo ?? '', Validators.maxLength(50)],
      note: [this.data?.contact?.note ?? '', Validators.maxLength(500)],
      default: [{ value: this.data?.contact?.principale ?? false, disabled: true }],
    });
  }

  onClose() {
    this.dialogRef.close();
  }

  onCancel() {
    this.dialogRef.close();
  }

  onSave() {
    if (this.addContactForm.invalid) {
      this.addContactForm.markAllAsTouched();
      return;
    }

    this.dialogRef.close(this.addContactForm.getRawValue());
  }
}
